<template>
  <div class="profile-info">
    <!-- settings -->
    <div class="profile-info__content">
      <!-- image -->
      <AppForm class="profile-info__image" enctype="multipart/form-data">
        <UserAvatar size="large" :user="currentUser" :tooltip="false" @click.native="uploadFile" />
        <input id="profile-image" type="file" hidden @change="fileUploaded" accept="image/*" />
      </AppForm>
      <!-- info -->
      <div class="profile-info__info">
        <!-- name -->
        <AppInput
          :label="$t('ui.user.name')"
          v-model="currentUser.first_name"
          :floating-label="false"
          variant="filled"
          disabled
        />
        <!-- last name -->
        <AppInput
          :label="$t('ui.user.last_name')"
          :value="currentUser.last_name"
          :floating-label="false"
          variant="filled"
          disabled
        />
        <!-- email -->
        <AppInput
          label="Email"
          :value="currentUser.email"
          :floating-label="false"
          variant="filled"
          disabled
        />
        <!-- username -->
        <AppInput
          :label="$t('ui.user.username')"
          :value="currentUser.username"
          :floating-label="false"
          variant="filled"
          disabled
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import AppInput from 'Ui/AppInput'
import UserAvatar from 'Components/UserAvatar'
import AppForm from 'Components/AppForm'

export default {
  name: 'ProfileInfo',

  components: {
    AppForm,
    AppInput,
    UserAvatar,
  },

  data() {
    return {
      userData: {
        avatar: '',
      },
    }
  },

  methods: {
    uploadFile() {
      const hiddenInput = document.querySelector('#profile-image')
      hiddenInput.click()
    },

    async fileUploaded(event) {
      this.userData.avatar = event.target.files[0]
      let formData = new FormData()
      formData.append('avatar', this.userData.avatar, this.userData.avatar.name)

      await this.$store.dispatch('user/updateUserInfo', formData)
    },

    submitCloseAciton() {
      this.$emit('close')
    },
  },

  computed: {
    currentUser() {
      return this.$store.state.user.currentUser
    },
  },
}
</script>

<style scoped>
.profile-info__header .app-heading {
  font-weight: 400;
}

.profile-info__content {
  display: flex;
  flex-flow: row;
  gap: 50px;
  margin-top: 20px;
}

.profile-info__image .user {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.profile-info__image .user:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-color: var(--rgba-black-600);
}

.profile-info__image .user:after {
  position: absolute;
  content: '\f030';
  font-family: var(--font-awesome);
  font-size: 24px;
  color: #fff;
  transform: translateY(-10px);
}

.profile-info__image .user:before,
.profile-info__image .user:after {
  pointer-events: none;
  opacity: 0;
  transition: var(--transition--default);
}

.profile-info__image .user:hover:before,
.profile-info__image .user:hover:after {
  opacity: 1;
}

.profile-info__image .user:hover:after {
  transform: translateY(0px);
}

.profile-info__image .user >>> .user__short-name {
  font-size: 20px;
}

.profile-info__info {
  display: grid;
  width: 100%;
  gap: 20px;
}

.profile-info__info >>> .app-input-field .app-input-field__control {
  flex-flow: row-reverse;
  align-items: center;
}

/* Responsive -------- */
@media (min-width: 681px) {
  .profile-info__info >>> .app-input-field .app-input-field__control label {
    flex: 0 0 80px;
  }
}

@media (max-width: 680px) {
  .profile-info__content {
    flex-flow: row wrap;
    justify-content: center;
  }

  .profile-info__info >>> .app-input-field .app-input-field__control {
    flex-flow: column-reverse wrap;
    align-items: flex-start;
  }
}
</style>
